import React from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  Button,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import Header from "./header";
import Footer from "./footer";
import AdmissionPage from "./AdmissionPage";
import AdmissionEssentials from "./AdmissionEssentials";
// import Seo from "./components/Seo";
// import seoRoutes from "../seo/seoRoutes";

export default function AdmissonG() {
  return (
    <>
      <Header />

      {/* Breadcrumb / Hero */}
      <Box
        sx={{
          py: { xs: 6, sm: 8 },
          background: "linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)",
          borderBottom: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: 26, sm: 32, md: 38 },
                letterSpacing: 0.2,
              }}
            >
              Admission Guide
            </Typography>

            <Box
              sx={{
                mt: 1.5,
                color: "text.secondary",
                fontSize: { xs: 13.5, sm: 14.5 },
              }}
            >
              <Link to="/" style={{ textDecoration: "none" }}>
                Home
              </Link>{" "}
              / <Typography component="span">Admission Guide</Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Intro section */}
      <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: "background.default" }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
            <Grid item xs={12} md={6}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  overflow: "hidden",
                  borderRadius: 3,
                  boxShadow:
                    "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
                  border: (t) => `1px solid ${t.palette.divider}`,
                }}
              >
                <CardMedia
                  component="img"
                  alt="Admission"
                  image="/assets/images/others/video-04.jpg"
                  sx={{ height: { xs: 220, sm: 260, md: 1000 }, maxHeight: 420 }}
                />
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card
                elevation={0}
                sx={{
                  p: { xs: 2, sm: 2.5, md: 3 },
                  height: "100%",
                  borderRadius: 3,
                  boxShadow:
                    "0 1px 2px rgba(0,0,0,.06), 0 16px 40px rgba(0,0,0,.08)",
                  border: (t) => `1px solid ${t.palette.divider}`,
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: 18, sm: 20, md: 22 },
                    mb: 1,
                  }}
                >
                  Guides to Intermediates Study
                </Typography>

                <Typography
                  sx={{
                    color: "text.secondary",
                    fontSize: { xs: 14, sm: 15 },
                    lineHeight: 1.8,
                  }}
                >
                  Learn how to apply, eligibility criteria, important dates, and
                  what to expect during counseling and admission.
                </Typography>

                <Typography
                  sx={{
                    mt: 2,
                    fontWeight: 700,
                    fontSize: { xs: 15, sm: 16 },
                  }}
                >
                  Our goal goes beyond fees
                </Typography>
                <Typography
                  sx={{
                    color: "text.secondary",
                    fontSize: { xs: 14, sm: 15 },
                    lineHeight: 1.8,
                    mt: 0.5,
                  }}
                >
                  We focus on the right stream fit, foundational readiness, and
                  support throughout the academic year.
                </Typography>

                <Button
  component={Link}
  to="/contact"
  variant="contained"
  size="medium"
  sx={{
    mt: 2.5,
    borderRadius: 2,
    fontWeight: 700,
    color: "#fff",
    transition: "all 0.25s ease",
    "&:hover": {
      color: "#fff",
      transform: "translateY(-1px)",
      boxShadow: (theme) =>
        `0 6px 16px ${theme.palette.primary.main}55`,
    },
  }}
>
  Applying to College
</Button>

              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Courses & Fees (your separate component) */}
      <Box sx={{ pt: { xs: 2, md: 3 }, pb: { xs: 2, md: 4 } }}>
        <AdmissionEssentials />
        {/* Keep your AdmissionPage below for fees & tabs */}
      </Box>
      <Box sx={{ pt: { xs: 2, md: 3 }, pb: { xs: 2, md: 4 } }}>
        <AdmissionPage/>
        {/* Keep your AdmissionPage below for fees & tabs */}
      </Box>

      {/* Contact tiles */}
      <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: "background.default" }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 3, md: 4 }}>
            <Grid item xs={12} md={6}>
              <Card
                variant="outlined"
                sx={{
                  height: "100%",
                  p: { xs: 2, sm: 2.5 },
                  borderRadius: 3,
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Box sx={{ fontSize: 32, mb: 1 }}>📞</Box>
                  <Typography sx={{ fontWeight: 800, mb: 0.5, fontSize: 18 }}>
                    Call us
                  </Typography>
                  <Typography
                    sx={{ color: "text.secondary", fontSize: 14, mb: 0.75 }}
                  >
                    <a href="tel:+91 8002748899">(+91) 8002748899</a>
                  </Typography>
                  <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                    <a href="tel:+91 7479708899">(+91) 7479708899</a>
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={6}>
              <Card variant="outlined" sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 3, height: "100%" }}>
                <Box sx={{ textAlign: "center" }}>
                  <Box sx={{ fontSize: 32, mb: 1 }}>📍</Box>
                  <Typography sx={{ fontWeight: 800, mb: 0.5, fontSize: 18 }}>
                    Visit us
                  </Typography>
                  <Typography sx={{ color: "text.secondary", fontSize: 14, lineHeight: 1.8 }}>
                    <strong>Main Campus:</strong> Vill: Jonhiya (Tarba-Kharba), P.O. Maheshra,
                    P.S. Daru, Hazaribagh, Jharkhand – 825313
                    <br />
                    <strong>City Campus:</strong> AISECT University, Matwari Chowk, Hazaribagh,
                    Jharkhand – 825301
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Divider />
      <Footer />
    </>
  );
}


// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   Container,
//   Breadcrumbs,
//   Typography,
//   Grid,
//   Card,
//   CardMedia,
//   Button,
//   Divider,
//   Box,
//   Tabs,
// } from "@mui/material";
// import { PlayArrow, Phone, LocationOn } from "@mui/icons-material";
// import "../assets/css/style.css";
// import Header from "./header";
// import Footer from "./footer";
// import AdmissionPage from "./AdmissionPage";
// import "react-bootstrap";
// import sal from "sal.js";
// export default function AdmissonG() {
//   return (
//     <>
//       <Header />
//       <Box>
//         {/* Breadcrumb Area */}
//         <div className="rbt-breadcrumb-default ptb--100 ptb_md--50 ptb_sm--30 bg-gradient-1">
//           <div className="container">
//             <div className="row">
//               <div className="col-lg-12">
//                 <div className="breadcrumb-inner text-center">
//                   <h2 className="title">Admission Guide</h2>
//                   <ul className="page-list">
//                     <li className="rbt-breadcrumb-item">
//                       <Link to="/">Home</Link>
//                       {/* <a href="#">Home</a> */}
//                     </li>
//                     <li>
//                       <div className="icon-right">
//                         <i className="feather-chevron-right" />
//                       </div>
//                     </li>
//                     <li className="rbt-breadcrumb-item active">
//                       Admission Guide
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         {/* End Breadcrumb Area */}
//         {/* End Breadcrumb Area */}
//         <div className="rbt-admission-area bg-color-white rbt-section-gapTop">
//           <Container>
//             <Grid container spacing={5}>
//               <Grid item lg={6}>
//                 <Card>
//                   <CardMedia
//                     component="img"
//                     alt="Video Images"
//                     height="100%"
//                     image="assets/images/others/video-04.jpg"
//                   />
//                   {/* <Button
//                     variant="outlined"
//                     className="popup-video position-to-top"
//                     href="https://www.youtube.com/watch?v=nA1Aqp0sPQo"
//                   >
//                     <PlayArrow />
//                   </Button> */}
//                 </Card>
//               </Grid>
//               <Grid item lg={6}>
//                 {/* <div className="col-lg-6"> */}
//                 <div className="addmission-guide-content pl--50 pl_sm--0 pl_md--0 pl_lg--0">
//                   <h3 className="title">Guides to undergraduate study</h3>
//                   <p>
//                     Lorem Ipsum is simply dummy text of the printing and
//                     typesetting industry. Lorem Ipsum has been.
//                   </p>
//                   <p>
//                     When an unknown printer took a galley of type and scrambled
//                     it to make a type specimen book. It has survived not only
//                     five centuries.
//                   </p>
//                   <h5>The goal should be more than money</h5>
//                   <p>
//                     Lorem Ipsum is simply dummy text of the printing and
//                     typesetting industry.
//                   </p>
//                   <div className="apply-btn">
//                     <a
//                       className="rbt-btn btn-gradient radius-round icon-hover"
//                       href="#"
//                     >
//                       <span className="btn-text">Applying to College</span>
//                       <span className="btn-icon">
//                         <i className="feather-arrow-right" />
//                       </span>
//                     </a>
//                   </div>
//                 </div>
//                 {/* </div> */}
//               </Grid>
//             </Grid>
//           </Container>
//         </div>
//         <Box sx={{ pt: "20px", pb: "20px" }}>
//           {" "}
//           <AdmissionPage />
//         </Box>

//         <div className="rbt-conatct-area bg-color-white pt--60 rbt-section-gapBottom">
//           <Container>
//             <Grid container spacing={5}>
//               <Grid item lg={6} md={6} sm={6} xs={12}>
//                 <Card sx={{ height: "330px" }} variant="outlined">
//                   <div className="rbt-address text-center">
//                     <div className="icon">
//                       <i className="feather-headphones" />
//                     </div>
//                     <div className="inner">
//                       <h4 className="title">Call us</h4>
//                       <p>
//                         <a href="tel:(+91) 9999999999">+(+91) 9999999999</a>
//                       </p>
//                       <p>
//                         <a href="tel:+(+91) 9999999999">+(+91) 9999999999</a>
//                       </p>
//                     </div>
//                   </div>
//                 </Card>
//               </Grid>
//               <Grid item lg={6} md={6} sm={6} xs={12}>
//                 <Card variant="outlined">
//                   <div className="rbt-address text-center">
//                     <div className="icon">
//                       <i className="feather-map-pin" />
//                     </div>
//                     <div className="inner">
//                       <h4 className="title">Visit us</h4>
//                       <p>
//                         Main Campus : Vill: Jonhiya, (Tarba-Kharba), P.O. :
//                         Maheshra,P.S. : Daru, Dist. : Hazaribagh, Jharkhand -
//                         825313
//                         <br />
//                         City Campus : AISECT University,Matwari Chowk,
//                         Hazaribagh, Jharkhand - 825301
//                       </p>
//                     </div>
//                   </div>
//                 </Card>
//               </Grid>
//             </Grid>
//           </Container>
//         </div>
//         <Divider />
//       </Box>
//       <Box sx={{ pb: "30px" }}></Box>
//       <Footer />
//     </>
//   );
// }
